import React, { TextareaHTMLAttributes } from 'react';
import { FormState } from 'src/types';
import { StyledTextArea } from './TextArea.styles';

export interface TextAreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  state: FormState;
  'data-testid'?: string;
  forwardRef?: React.Ref<HTMLTextAreaElement>;
  className?: string;
  $removeMarginBottom?: boolean;
}

export const TextArea: React.FC<TextAreaProps> = ({
  state,
  forwardRef,
  ...props
}: TextAreaProps) => {
  const isReadOnly = state === FormState.READONLY;

  return (
    <StyledTextArea
      {...props}
      readOnly={isReadOnly}
      aria-readonly={isReadOnly}
      state={state}
      disabled={state === FormState.DISABLED}
      data-testid={props['data-testid']}
      id={props['data-testid']}
      aria-label="Text Area"
      ref={forwardRef}
    />
  );
};
